import React from "react";

function HighSpeedDoubleRotary() {
  return (
    <>
      <style>{`
      /* Technical Specification Table */
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }

      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        text-transform: capitalize;
        letter-spacing: 0.5px;
        margin-bottom: 20px;
        padding: 0;
      }

      .table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
        background: white;
      }

      .table-bordered {
        border: 1px solid #ddd;
      }

      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        line-height: 1.42857;
        font-size: 14px;
        color: #333;
      }

      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }

      .table tbody tr:nth-child(odd) {
        background-color: white;
      }

      .table td:first-child {
        font-weight: 500;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* start: Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">
                    High Speed Double Side Rotary Tablet Press
                  </h1>
                  <div className="tj-page-link">
                    <span>
                      <i className="fa-solid fa-home"></i>
                    </span>
                    <span>
                      <a href="/">Home</a>
                    </span>
                    <span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                    <span>
                      <span>High Speed Double Side Rotary Tablet Press</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>
        {/* end: Breadcrumb Section */}

        {/* start: Blog Section */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">
              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">
                  {/* MAIN IMAGE */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                  >
                    <img
                      src="assets/images/SD_PHRMA_ALL_MIX _JPGS/3.png"
                      alt="High Speed Double Side Rotary Tablet Press"
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "500px",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  <h2 className="title title-anim">
                    High Speed Double Side Rotary Tablet Press
                  </h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The High Speed Double Side Rotary Tablet Press is designed
                      for large-scale pharmaceutical tablet production with
                      exceptional accuracy and efficiency. Its double-sided
                      compression system offers maximum output while maintaining
                      consistent tablet hardness, thickness, and weight
                      uniformity.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      With advanced features like force feeders, high
                      compression capability, stainless steel body, and safety
                      interlocks, this machine is ideal for high-volume tablet
                      manufacturers requiring robust performance and
                      reliability.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className="image-box wow fadeInUp"
                          data-wow-delay=".3s"
                        >
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/4.png"
                            alt="Image"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div
                          className="image-box wow fadeInUp"
                          data-wow-delay=".5s"
                        >
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/5.png"
                            alt="Image"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATION TABLE */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Model</td>
                          <td>DPM-H-45</td>
                          <td>DPM-H-51</td>
                          <td>DPM-H-61</td>
                          <td>DPM-H-75</td>
                        </tr>

                        <tr>
                          <td>Number of Stations</td>
                          <td>45</td>
                          <td>51</td>
                          <td>61</td>
                          <td>75</td>
                        </tr>

                        <tr>
                          <td>Output (Tablets per Hour)</td>
                          <td>405,000</td>
                          <td>459,000</td>
                          <td>549,000</td>
                          <td>675,000</td>
                        </tr>

                        <tr>
                          <td>Max Tablet Diameter</td>
                          <td>25 mm</td>
                          <td>25 mm</td>
                          <td>16 mm</td>
                          <td>16 mm</td>
                        </tr>

                        <tr>
                          <td>Max Depth of Fill</td>
                          <td>20 mm</td>
                          <td>20 mm</td>
                          <td>17 mm</td>
                          <td>17 mm</td>
                        </tr>

                        <tr>
                          <td>Upper Punch Penetration</td>
                          <td>1.5–8 mm</td>
                          <td>1.5–8 mm</td>
                          <td>1.5–8 mm</td>
                          <td>1.5–8 mm</td>
                        </tr>

                        <tr>
                          <td>Main Compression Pressure</td>
                          <td>10 Tons</td>
                          <td>10 Tons</td>
                          <td>6.5 Tons</td>
                          <td>6.5 Tons</td>
                        </tr>

                        <tr>
                          <td>Pre-Compression Pressure</td>
                          <td>2 Tons</td>
                          <td>2 Tons</td>
                          <td>1 Ton</td>
                          <td>1 Ton</td>
                        </tr>

                        <tr>
                          <td>Turret Speed</td>
                          <td>30 RPM</td>
                          <td>30 RPM</td>
                          <td>30 RPM</td>
                          <td>30 RPM</td>
                        </tr>

                        <tr>
                          <td>Main Motor</td>
                          <td>7.5 HP</td>
                          <td>7.5 HP</td>
                          <td>5 HP</td>
                          <td>5 HP</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>1750 × 1650 × 1900 mm</td>
                          <td>1750 × 1650 × 1900 mm</td>
                          <td>1750 × 1650 × 1900 mm</td>
                          <td>1750 × 1650 × 1900 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>2600 kg</td>
                          <td>2600 kg</td>
                          <td>2400 kg</td>
                          <td>2400 kg</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">
                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>
                      <li>
                        <a
                          className="active"
                          href="/single-rotary-tablet-press"
                        >
                          Single Rotary Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>

                      <li>
                        <a href="/mini-tablet-press">
                          Mini Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>

                      <li>
                        <a href="/r-d-tablet-press">
                          R&D Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-layer-tablet-press">
                          Multi Layer Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>

                      <li>
                        <a href="/lab-tablet-press">
                          ESG Consulting
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>

                      <li>
                        <a href="service-details.html">
                          Development Hub
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div
                    className="tj-sidebar-widget widget-feature-item wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="feature-box">
                      <div className="feature-content">
                        <h2 className="title">Modern</h2>
                        <span>Home Makeover</span>
                        <a
                          className="read-more feature-contact"
                          href="tel:8321890640"
                        >
                          <i className="fa-solid fa-phone"></i>
                          <span>+8 (321) 890-640</span>
                        </a>
                      </div>

                      <div className="feature-images">
                        <img
                          src="assets/images/service/service-ad.webp"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* end: Blog Section */}
      </main>
    </>
  );
}

export default HighSpeedDoubleRotary;
